module.exports = __webpack_public_path__ + "img/logo.1bf1b8be.png";